// Assets Index - GesOps LLC
// Archivo central para importar y exportar todos los assets del proyecto

// ===== LOGOS =====
import logoHeader from './logos/HEADERNAVBAR.png';
import logoFooter from './logos/FOOTER.png';

// ===== EXPORTACIONES =====
export const logos = {
  header: logoHeader,
  footer: logoFooter,
};

// Exportación por defecto con todos los assets
export default {
  logos,
};

// ===== EJEMPLO DE USO =====
/*
// En cualquier componente:
import { logos } from '../assets';

// Uso en JSX:
<img src={logos.header} alt="GesOps LLC" />
<img src={logos.footer} alt="GesOps LLC" />
*/
